import { Star } from "lucide-react";

export const StarRating = ({ value = 0, onChange, size = 18, testid }) => {
  const interactive = typeof onChange === "function";
  return (
    <div className="flex items-center gap-1" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={!interactive}
          onClick={() => interactive && onChange(n)}
          className={interactive ? "transition-transform hover:scale-110" : "cursor-default"}
          data-testid={testid ? `${testid}-star-${n}` : undefined}
          aria-label={`${n} star`}
        >
          <Star
            style={{ width: size, height: size }}
            className={n <= value ? "fill-gold text-gold" : "text-charcoal-border"}
          />
        </button>
      ))}
    </div>
  );
};
